import {Field} from "formik";
import {SearchInput} from "../form/SearchInput";
import {Select} from "./Select";
import {getCategories} from './DataHelpers'

export function FilterForm(props) {

    const onChangeCategory = (value) => props.setCategory(value);
    const onChangeFilter = (value) => props.setFilter(value);
    const onChangeSort = (value) => props.setSort(value);
    const onChangeSearch = (event) => props.setSearch(event.target.value);

    return (
        <div>
            <div className="flex w-full px-8 my-4 justify-center">
                <Field name="search" label="Suche" onInput={onChangeSearch} component={SearchInput}
                       placeholder="Suchbegriff eingeben"/>
            </div>
            <div className="w-full grid grid-cols-1 px-8 gap-3 md:gap-6 sm:grid-cols-2 lg:grid-cols-3">
                <div className="col-span-1 p-2 md:p-4">
                    <Field name="category" label="Kategorie"
                           placeholder="Bitte Kategorie auswählen"
                           component={Select}
                           onChange={onChangeCategory}
                           options={getCategories()}/>
                </div>
                <div className="col-span-1 p-2 md:p-4">
                    <Field name="filter" label="Filter"
                           onChange={onChangeFilter}
                           placeholder="Auswahl filtern" component={Select} options={[
                        {id: 'all', name: 'alle'},
                        {id: 'amount', name: 'Coupon'},
                        {id: 'percent', name: 'Rabatt in %'},
                    ]}/>
                </div>
                <div className="col-span-1 p-2 md:p-4">
                    <Field name="sort" label="Sortierung" placeholder="Auswahl sortieren" component={Select}
                           onChange={onChangeSort}
                           options={[
                               {id: 'popular', name: 'Populär'},
                               {id: 'neueste', name: 'Neuste'},
                               {id: 'alphabetisch', name: 'Alphabetisch'},
                           ]}/>
                </div>
            </div>
        </div>
    )
}
